<template>
  <div class="columns is-centered is-vcentered">
    <div class="column is-6">
      <div class="box content">
        <div
          v-if="emailSent"
        >
          <div class="columns">
            <div class="column has-text-centered">
              <h2 class="title is-2">
                Forgot Password
              </h2>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p>An <strong>email confirmation</strong> has been sent with <strong>a link to reset</strong> your password. Check your inbox, if you have trouble locating the email, please check your <strong>junk</strong> email folder.</p>
              <br>
              <div class="field has-text-centered">
                <router-link :to="{ name: 'login' }">
                  <button
                    id="back-btn"
                    type="button"
                    class="button is-primary"
                  >
                    Back to Login
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="columns is-multiline"
        >
          <div class="column is-12 has-text-centered">
            <h2 class="title is-2">
              Forgot Password
            </h2>
            <div class="subtitle is-2">
              Enter <strong>your e-mail address</strong> below. An email confirmation will be sent to reset your password.
            </div>
          </div>
          <div class="column is-12">
            <validation-observer
              ref="form-reset-password"
              tag="form"
            >
              <div class="field">
                <textbox-vee
                  id="email-address"
                  v-model="emailAddress"
                  placeholder="E-mail Address"
                  rules="required"
                  required
                />
              </div>
              <div class="field has-text-centered">
                <button
                  id="reset-btn"
                  type="button"
                  class="button is-primary"
                  :class="isSending ? 'is-loading' : ''"
                  :disabled="isSending"
                  @click="sendEmail"
                >
                  Reset Password
                </button>
              </div>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Textbox } from '@phila/phila-ui';
import { withValidation } from 'vee-validate';

const TextboxVee = withValidation(Textbox);

export default {
  components: {
    TextboxVee,
  },
  data() {
    return {
      emailAddress: '',
      isSending: false,
      emailSent: false,
    };
  },
  methods: {
    async sendEmail() {
      const isValid = await this.$refs['form-reset-password'].validate();
      this.isSending = true;
      if (isValid) {
        let request = await this.$store.dispatch('admin/forgotPassword', this.emailAddress);
        if (request) {
          this.emailSent = true;
        } else {
          this.isSending = false;
        }
      } else {
        this.isSending = false;
      }
    },
  },
};
</script>
